import request from '@/utils/request' //引入封装好的 axios 请求


//易贷码 列表接口 ---监管机构
export function ydmReqList(data = {}) {
    return request({
        url: '/api/v1/ydm/reqList',
        method: 'get',
        params: data
    })
}

//易贷码 列表接口  --银行金融机构
export function reqListByBank(data = {}) {
    return request({
        url: '/api/v1/ydm/reqListByBank',
        method: 'get',
        params: data
    })
}

//银行+信用办的融资需求明细
export function selectDemandListByCondition (data = {}) {
    return request({
        url: '/api/v1/demand/selectDemandListByCondition',
        method: 'post',
        data: data
    })
}
//企业的融资需求明细
export function selectDemandList (data = {}) {
    return request({
        url: '/api/v1/demand/selectDemandList',
        method: 'post',
        data: data
    })
}
//融资需求明细 银行受理
export function updateStatusById (data = {}) {
    return request({
        url: '/api/v1/demand/updateStatusById',
        method: 'post',
        data: data
    })
}


